var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"activity-status-label uppercase font-black tracking-wide text-center rounded",class:[
    `bg-${_vm.labels[_vm.status]}`,
    _vm.status === 9 ? 'activity-status-label--pending-rescheduling' : 'text-white',
  ],style:({ fontSize: _vm.fontSize + 'rem' })},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.labels[_vm.status]))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }